"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * keepkey-sdk-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class AddressApi extends runtime.BaseAPI {
    /**
     * Get a Binance Chain address, loading it into the current session and optionally displaying it on-device.
     * Get Binance Address
     */
    async binanceGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.BinanceGetAddressRequest === null || requestParameters.BinanceGetAddressRequest === undefined) {
            throw new runtime.RequiredError('BinanceGetAddressRequest', 'Required parameter requestParameters.BinanceGetAddressRequest was null or undefined when calling binanceGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/addresses/bnb`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.BinanceGetAddressRequestToJSON)(requestParameters.BinanceGetAddressRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.BinanceGetAddress200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get a Binance Chain address, loading it into the current session and optionally displaying it on-device.
     * Get Binance Address
     */
    async binanceGetAddress(BinanceGetAddressRequest, initOverrides) {
        const response = await this.binanceGetAddressRaw({ BinanceGetAddressRequest: BinanceGetAddressRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Get a Cosmos address, loading it into the current session and optionally displaying it on-device.
     * Get Cosmos Address
     */
    async cosmosGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.BinanceGetAddressRequest === null || requestParameters.BinanceGetAddressRequest === undefined) {
            throw new runtime.RequiredError('BinanceGetAddressRequest', 'Required parameter requestParameters.BinanceGetAddressRequest was null or undefined when calling cosmosGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/addresses/cosmos`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.BinanceGetAddressRequestToJSON)(requestParameters.BinanceGetAddressRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.CosmosGetAddress200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get a Cosmos address, loading it into the current session and optionally displaying it on-device.
     * Get Cosmos Address
     */
    async cosmosGetAddress(BinanceGetAddressRequest, initOverrides) {
        const response = await this.cosmosGetAddressRaw({ BinanceGetAddressRequest: BinanceGetAddressRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Get an Ethereum address, loading it into the current session and optionally displaying it on-device.
     * Get Ethereum Address
     */
    async ethereumGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.BinanceGetAddressRequest === null || requestParameters.BinanceGetAddressRequest === undefined) {
            throw new runtime.RequiredError('BinanceGetAddressRequest', 'Required parameter requestParameters.BinanceGetAddressRequest was null or undefined when calling ethereumGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/addresses/eth`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.BinanceGetAddressRequestToJSON)(requestParameters.BinanceGetAddressRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.EthereumGetAddress200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get an Ethereum address, loading it into the current session and optionally displaying it on-device.
     * Get Ethereum Address
     */
    async ethereumGetAddress(BinanceGetAddressRequest, initOverrides) {
        const response = await this.ethereumGetAddressRaw({ BinanceGetAddressRequest: BinanceGetAddressRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Get a mayachain address, loading it into the current session and optionally displaying it on-device.
     * Get Thorchain Address
     */
    async mayachainGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.BinanceGetAddressRequest === null || requestParameters.BinanceGetAddressRequest === undefined) {
            throw new runtime.RequiredError('BinanceGetAddressRequest', 'Required parameter requestParameters.BinanceGetAddressRequest was null or undefined when calling mayachainGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/addresses/mayachain`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.BinanceGetAddressRequestToJSON)(requestParameters.BinanceGetAddressRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.CosmosGetAddress200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get a mayachain address, loading it into the current session and optionally displaying it on-device.
     * Get Thorchain Address
     */
    async mayachainGetAddress(BinanceGetAddressRequest, initOverrides) {
        const response = await this.mayachainGetAddressRaw({ BinanceGetAddressRequest: BinanceGetAddressRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Get a Cosmos address, loading it into the current session and optionally displaying it on-device.
     * Get Cosmos Address
     */
    async osmosisGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.BinanceGetAddressRequest === null || requestParameters.BinanceGetAddressRequest === undefined) {
            throw new runtime.RequiredError('BinanceGetAddressRequest', 'Required parameter requestParameters.BinanceGetAddressRequest was null or undefined when calling osmosisGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/addresses/osmosis`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.BinanceGetAddressRequestToJSON)(requestParameters.BinanceGetAddressRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.CosmosGetAddress200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get a Cosmos address, loading it into the current session and optionally displaying it on-device.
     * Get Cosmos Address
     */
    async osmosisGetAddress(BinanceGetAddressRequest, initOverrides) {
        const response = await this.osmosisGetAddressRaw({ BinanceGetAddressRequest: BinanceGetAddressRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Get a Tendermint address, loading it into the current session and optionally displaying it on-device.
     * Get Tendermint Address
     */
    async tendermintGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.BinanceGetAddressRequest === null || requestParameters.BinanceGetAddressRequest === undefined) {
            throw new runtime.RequiredError('BinanceGetAddressRequest', 'Required parameter requestParameters.BinanceGetAddressRequest was null or undefined when calling tendermintGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/addresses/tendermint`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.BinanceGetAddressRequestToJSON)(requestParameters.BinanceGetAddressRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.EthereumGetAddress200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get a Tendermint address, loading it into the current session and optionally displaying it on-device.
     * Get Tendermint Address
     */
    async tendermintGetAddress(BinanceGetAddressRequest, initOverrides) {
        const response = await this.tendermintGetAddressRaw({ BinanceGetAddressRequest: BinanceGetAddressRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Get a Thorchain address, loading it into the current session and optionally displaying it on-device.
     * Get Thorchain Address
     */
    async thorchainGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.BinanceGetAddressRequest === null || requestParameters.BinanceGetAddressRequest === undefined) {
            throw new runtime.RequiredError('BinanceGetAddressRequest', 'Required parameter requestParameters.BinanceGetAddressRequest was null or undefined when calling thorchainGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/addresses/thorchain`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.BinanceGetAddressRequestToJSON)(requestParameters.BinanceGetAddressRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.CosmosGetAddress200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get a Thorchain address, loading it into the current session and optionally displaying it on-device.
     * Get Thorchain Address
     */
    async thorchainGetAddress(BinanceGetAddressRequest, initOverrides) {
        const response = await this.thorchainGetAddressRaw({ BinanceGetAddressRequest: BinanceGetAddressRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Get a Bitcoin/Dogecoin/Dash.... cont. (see coin-support) Chain address, loading it into the current session and optionally displaying it on-device.
     * Get Binance Address
     */
    async utxoGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.UtxoGetAddressRequest === null || requestParameters.UtxoGetAddressRequest === undefined) {
            throw new runtime.RequiredError('UtxoGetAddressRequest', 'Required parameter requestParameters.UtxoGetAddressRequest was null or undefined when calling utxoGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/addresses/utxo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.UtxoGetAddressRequestToJSON)(requestParameters.UtxoGetAddressRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.UtxoGetAddress200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get a Bitcoin/Dogecoin/Dash.... cont. (see coin-support) Chain address, loading it into the current session and optionally displaying it on-device.
     * Get Binance Address
     */
    async utxoGetAddress(UtxoGetAddressRequest, initOverrides) {
        const response = await this.utxoGetAddressRaw({ UtxoGetAddressRequest: UtxoGetAddressRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Get an XRP address, loading it into the current session and optionally displaying it on-device.
     * Get XRP Address
     */
    async xrpGetAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.BinanceGetAddressRequest === null || requestParameters.BinanceGetAddressRequest === undefined) {
            throw new runtime.RequiredError('BinanceGetAddressRequest', 'Required parameter requestParameters.BinanceGetAddressRequest was null or undefined when calling xrpGetAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/addresses/xrp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.BinanceGetAddressRequestToJSON)(requestParameters.BinanceGetAddressRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.CosmosGetAddress200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get an XRP address, loading it into the current session and optionally displaying it on-device.
     * Get XRP Address
     */
    async xrpGetAddress(BinanceGetAddressRequest, initOverrides) {
        const response = await this.xrpGetAddressRaw({ BinanceGetAddressRequest: BinanceGetAddressRequest }, initOverrides);
        return await response.value();
    }
}
exports.AddressApi = AddressApi;
